import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchProposalDetails = (payload) => {
  return {
    type: actionTypes.FETCH_PROPOSAL_DETAILS,
    formData: payload,
  };
};
// bi started
export const editProposalDetailsStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_PROPOSAL_DETAILS_START,
  };
};

export const editProposalDetailsSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_PROPOSAL_DETAILS_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

// export const fetchProposalDetailsSuccess = (payload, apiPath, res) => {
//   return async (dispatch) => {
//     dispatch(editProposalDetailsStarted());
//     axiosRequest.put(apiPath, payload).then((res) => {
//       //console.log(res);
//      dispatch(fetchProposalDetails(res?.ProposerDetails));
//     });
//   };
// };

export const fetchProposalDetailsSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editProposalDetailsStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      dispatch(fetchProposalDetails(res?.ProposerDetails));
      return res; // Return the response
    } catch (err) {
      // Handle errors here if needed
      console.error("Error in fetchProposalDetailsSuccess:", err);
      throw err; // Re-throw the error to propagate it to the caller
    }
  };
};

export const editProposalDetailsFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_PROPOSAL_DETAILS_FAIL,
    error: errMsg,
  };
};

export const checkMedicalApplicability = (payload) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.CHECK_MEDICAL_APPLICABILITY_START });
    try {
      const res = await axiosRequest.post("user/check_medical_applicability", payload, { secure: true });
      dispatch({ type: actionTypes.CHECK_MEDICAL_APPLICABILITY_SUCCESS, response: res });
      return res;
    } catch (err) {
      dispatch({ type: actionTypes.CHECK_MEDICAL_APPLICABILITY_FAIL, error: err });
      throw err;
    }
  };
};

export const scheduleMedical = (payload) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.SCHEDULE_MEDICAL_START });
    try {
      const res = await axiosRequest.post("user/tpa/schedule_medical", payload, { secure: true });
      dispatch({ type: actionTypes.SCHEDULE_MEDICAL_SUCCESS, response: res });
      return res;
    } catch (err) {
      dispatch({ type: actionTypes.SCHEDULE_MEDICAL_FAIL, error: err });
      throw err;
    }
  };
};

export const EkycFacematch = (payload) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.EKYC_FACEMATCH_START });
    try {
      const res = await axiosRequest.post("user/ekyc_facematch", payload, { secure: true });
      dispatch({ type: actionTypes.EKYC_FACEMATCH_SUCCESS, response: res });
      console.log("result ekyc", res);
      return res;
    } catch (err) {
      dispatch({ type: actionTypes.EKYC_FACEMATCH_FAIL, error: err });
      throw err;
    }
  };
};

